export default {
    key: 'theme-base',
    name: 'theme-base',
    version: '0.0.1',
    author: 'Gang Zhuo',

    login: {
        // 登录页面走马灯
        carousel: {
            visiable: true,
            imgs: [
                '/theme/base/img/loginbg_01.jpg',
                '/theme/base/img/loginbg_02.jpg',
                '/theme/base/img/loginbg_03.jpg',
                '/theme/base/img/loginbg_04.jpg',
                '/theme/base/img/loginbg_05.jpg',
                '/theme/base/img/loginbg_06.jpg',
                '/theme/base/img/loginbg_07.jpg',
                '/theme/base/img/loginbg_08.jpg',
                '/theme/base/img/loginbg_09.jpg',
            ],
            interval: 3000,
        }
    },

    header: {
        visiable: true,
        style: {
            height: '110px',
            //backgroundImage: 'url("/theme/default/img/header.png")'
        },
        logo: {
            visiable: true,
            img: '/theme/default/img/logo.png',
            style: {
                //height: '10rem'
            }
        },
        title: {
            visiable: true,
            text: '汉中南湖综合管理平台'
        },
        avatarUrl: '/img/logo.png'
    },

    footer: {
        visiable: false,
    },
    
    sidemenu: {
        visiable: true,
    },

};